/*
 * CAPTURE-OWNED MODULE
 * BuildStaleBanner — "this tab is running an old bundle".
 *
 * Renders nothing until the tab is known to be stale, so it costs nothing on the
 * happy path. Once shown it STAYS shown: there is no dismiss, and that is the
 * point rather than an oversight. A dismissable banner is one a person clicks
 * away and then keeps using the stale tab, which is the exact state that minted
 * a duplicate OAuth channel on 2026-08-29.
 *
 * It asks; it never acts. An automatic reload would fire mid-form and
 * mid-OAuth-return, and destroying someone's half-finished work to fix a
 * staleness problem is worse than the staleness.
 */
import React from 'react';
import { useBuildStaleness } from '../utils/buildStamp';
import './BuildStaleBanner.css';

export default function BuildStaleBanner() {
  const stale = useBuildStaleness();

  if (!stale) return null;

  return (
    <div className="bsb-banner" role="status">
      <span className="bsb-text">A new version of Capture is available.</span>
      <button
        type="button"
        className="bsb-reload"
        onClick={() => window.location.reload()}
      >
        Reload
      </button>
    </div>
  );
}
